import { Button } from 'components/ui/button';
import BotCard from './BotCard';
import { Bot } from 'features/bot-builder/types/apiResponses';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import toast from 'react-hot-toast';
import { Sparkles } from 'lucide-react';

interface HistoryCardProps {
  bots: Bot[];
  setShowForm: (value: boolean) => void;
}

const HistoryCard = ({ bots, setShowForm }: HistoryCardProps) => {
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);

  const handleCreateNewBot = () => {
    if (!isAuthenticated) {
      toast.error("Please login or sign up to create your new bot");
      return;
    }
    setShowForm(true);
  };

  return (
    <div className="w-full">
      <div className="flex flex-row items-center justify-between mb-6">
        <h1 className="text-xl md:text-[28px] font-bold">Your telegram bots</h1>
        <Button
          variant="customSecondary"
          className="text-[14px] font-normal bg-secondary rounded-md"
          onClick={handleCreateNewBot}
        >
          Create new bot
        </Button>
      </div>
      
      {bots.length === 0 ? (
        <div className="bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-800 dark:to-gray-900 rounded-lg p-8 text-center shadow-sm border border-gray-200 dark:border-gray-700">
          <div className="flex justify-center mb-4">
            <div className="bg-primary/10 p-3 rounded-full">
              <Sparkles size={32} className="text-primary" />
            </div>
          </div>
          <h2 className="text-2xl font-bold mb-2">Create your first Telegram bot</h2>
          <p className="text-gray-600 dark:text-gray-300 mb-6 max-w-lg mx-auto">
            Build AI-powered Telegram bots in minutes with no coding required. Automate responses, integrate with services, and engage your audience 24/7.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
            <Button
              variant="customPrimary"
              className="font-medium px-6 py-2 w-full sm:w-auto"
              onClick={handleCreateNewBot}
            >
              Create your first bot
            </Button>
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10">
          {bots.map((bot: Bot, idx) => {
            return <BotCard key={idx} bot={bot} />;
          })}
          {bots.length === 1 && (
            <div className="bg-background-main dark:bg-[#2B2B2B] rounded-md mt-6 flex items-center justify-center max-md:hidden p-10 dark:text-white">
              <div className="text-center">
                <h2 className="text-4xl font-bold text-primary-600 mb-4">Smarter bots,<br />better outcomes</h2>
                <p className="text-lg mt-4">Build advanced AI-powered bots,<br />tailored to your unique needs.</p>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default HistoryCard;
